import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { catchError, startWith, switchMap, tap } from 'rxjs/operators';
import { NEVER, Subscription } from 'rxjs';
import { Tutorial } from '../../models/tutorial';
import { HowToService } from '../../services/how-to.service';
import { VideoComponent } from '../video/video.component';
import { TutorialSkeletonComponent } from '../tutorial-skeleton/tutorial-skeleton.component';
import { TutorialComponent } from '../tutorial/tutorial.component';

@Component({
  selector: 'app-latest-tutorials',
  templateUrl: './latest-tutorials.component.html',
  styleUrls: ['./latest-tutorials.component.scss'],
  imports: [TutorialSkeletonComponent, TutorialComponent],
  standalone: true
})
export class LatestTutorialsComponent implements OnInit, OnDestroy {
  tutorials: Tutorial[] = [];
  state: 'loading' | 'ready' = 'loading';
  tutorialsBeingDownloaded: number[] = [];

  private subscription = new Subscription();

  constructor(
    private tutorialsService: HowToService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.tutorialsService
        .listRefreshed$()
        .pipe(
          startWith(null),
          tap(() => (this.state = 'loading')),
          switchMap(() => this.tutorialsService.getTutorials({ pageSize: 4 })),
          tap(response => {
            this.tutorials = response.data;
            this.state = 'ready';
          }),
          catchError(err => {
            console.error(err);
            this.state = 'ready';
            return NEVER;
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onTutorialClick({ type, url, name, id }: Tutorial, tutorialIndex: number) {
    if (type === 'Pdf') {
      this.tutorialsBeingDownloaded.push(tutorialIndex);
      this.subscription.add(
        this.tutorialsService
          .downloadPdf(id!)
          .pipe(tap(() => this.hideDownloadIndicator(tutorialIndex)))
          .subscribe()
      );
    } else {
      this.dialog.open(VideoComponent, {
        height: '720px',
        width: '1280px',
        data: { url, name }
      });
    }
  }

  private hideDownloadIndicator(tutorialIndex: number) {
    const index = this.tutorialsBeingDownloaded.indexOf(tutorialIndex);
    if (index !== -1) {
      this.tutorialsBeingDownloaded.splice(index, 1);
    }
  }
}
